// gatsby-browser.js

import React from "react";
import ExternalLinkFix from "./src/components/ExternalLinkFix";

export const wrapRootElement = ({ element }) => (
  <>
    <ExternalLinkFix />
    {element}
  </>
);

export const onRouteUpdate = ({ location }) => {
  setTimeout(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        const headerOffset = 96;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
        return;
      }
    }
    
    window.scrollTo(0, 0);
  }, 0);
};

